require('./globalPositionExpensesBars.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { ComparativeBarSimple } = require('commonsComponents/comparativeBarSimple');
const BAR_COLORS = {
    main: '#FCB900',
    secondary: '#ACBFCC'
};
const BAR_HEIGHT = 5;

const GlobalPositionExpensesBars = props => {
    const {maxExpenses, currentPeriod, comparePeriod } = props;
    let comparePeriodComponent;
    if (comparePeriod){
        comparePeriodComponent = (
            <div className="global-position-expenses-bars__previous-expenses">
                <ComparativeBarSimple
                    firstValue={comparePeriod}
                    totalValue={maxExpenses}
                    height={BAR_HEIGHT}
                    color={BAR_COLORS.secondary}
                />
            </div>
        )
    }
    return (
        <div>
            <div className="global-position-expenses-bars__current-expenses">
                <ComparativeBarSimple
                    firstValue={currentPeriod}
                    totalValue={maxExpenses}
                    height={BAR_HEIGHT}
                    color={BAR_COLORS.main}
                />
            </div>
            {comparePeriodComponent}
        </div>
    )
};

GlobalPositionExpensesBars.propTypes = {
    maxExpenses: PropTypes.number,
    currentPeriod: PropTypes.number,
    comparePeriod: PropTypes.number
};

module.exports = GlobalPositionExpensesBars;
